import { db } from '@/lib/firebase';
import type { Country } from '@/types/country';
import { collection, doc, getDoc, getDocs } from 'firebase/firestore';

export async function fetchCountriesFromPairs(): Promise<Country[]> {
  const snap = await getDocs(collection(db, 'transfer_pairs'));

  // Use a Map to deduplicate by ID.
  // Key: Normalized ID (uppercase, trimmed) -> Value: Country object
  const map = new Map<string, Country>();

  snap.docs.forEach(doc => {
    const d = doc.data();

    const processCountry = (id: string, name: string, currencyISO: string) => {
      if (!id || !name) return;
      // Normalize ID to upper case to treat 'sv' and 'SV' as the same
      const normalizedId = id.trim().toUpperCase();

      if (!map.has(normalizedId)) {
        map.set(normalizedId, {
          id: id.trim(), // Keep original casing or maybe uppercase? Standardizing usually better but let's just trim.
          name: name.trim(),
          currencyISO: currencyISO?.trim() || '',
        });
      }
    };

    if (d.originId && d.originName) {
      processCountry(d.originId, d.originName, d.originCurrencyISO);
    }
    if (d.destId && d.destinyName) {
      processCountry(d.destId, d.destinyName, d.destCurrencyISO);
    }
  });

  const sorted = Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));

  return sorted;
}

export interface RestrictionsConfig {
  exchangeControlCountries: string[];
}

export async function fetchRestrictions(): Promise<string[]> {
  const docRef = doc(db, 'app_config', 'restrictions');
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    const data = docSnap.data() as RestrictionsConfig;
    return data.exchangeControlCountries || [];
  }

  console.warn('Restrictions config document not found');
  return [];
}
